"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
require("bootstrap");
require("slick-carousel");
var _sweetalert = require("sweetalert2/src/sweetalert2");
var _sweetalert2 = _interopRequireDefault(_sweetalert);
var _jsCookie = require("js-cookie");
var _jsCookie2 = _interopRequireDefault(_jsCookie);
require("./scss/frontend/style.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
(0, _jquery2.default)(function () {
  (0, _jquery2.default)(document).on('click', '.inner-link', function () {
    var href = (0, _jquery2.default)(this).attr('href');
    var width = (0, _jquery2.default)(window).width();
    var offset = width > 720 ? 100 : 60;
    var $target = (0, _jquery2.default)(href);
    (0, _jquery2.default)('.navbar-collapse').collapse('hide');
    (0, _jquery2.default)('html, body').animate({
      scrollTop: (0, _jquery2.default)(href).offset().top - offset
    }, {
      duration: 1000,
      easing: "linear",
      step: function step(now, fx) {
        var offset = width > 720 ? 100 : 60;
        var newOffset = $target.offset().top - offset;
        if (fx.end !== newOffset) fx.end = newOffset;
      }
    });
  });
  if (!_jsCookie2.default.get('cookiebar') == 1) {
    _sweetalert2.default.fire({
      position: "bottom-left",
      title: "Política general sobre Cookies",
      text: "En Wong.pe nos preocupamos por mejorar tu experiencia de compra, sin descuidar la protección de tus datos personales. En consecuencia Wong.pe, usa dos tipos de cookies las Funcionales y las de Analítica y Optimización ¿consiente el uso de las cookies?",
      confirmButtonText: "Sí Acepto",
      showCancelButton: false,
      cancelButtonText: "Cerrar",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: 'swal2-backdrop-show',
      footer: '<div class="content-footer" style="width:100%;display:inline-block; text-align:center;"><a href="https://wong.pe/institucional/politicas-de-cookies" target="_blank" style=";display:inline-block; margin:0 10px;"><u>Política de Cookies</u></a></div>',
      customClass: {
        container: 'swal2-shown',
        htmlContainer: 'swal2-content'
      }
    }).then(function (result) {
      if (result.isConfirmed) {
        _jsCookie2.default.set('cookiebar', 1, {
          expires: 365,
          path: '/'
        });
      }
      _sweetalert2.default.close();
    });
  }
  var tagArrowLeft = (0, _jquery2.default)('.slider-homepage').data('tag-arrow-left');
  var tagArrowRight = (0, _jquery2.default)('.slider-homepage').data('tag-arrow-right');
  (0, _jquery2.default)('.slider-homepage').on('init', function (event, slick, direction) {
    (0, _jquery2.default)('.slider-homepage .slick-slide a').each(function (index, element) {
      var id = (0, _jquery2.default)(element).data('id');
      (0, _jquery2.default)(element).attr('id', id);
    });
  });
  (0, _jquery2.default)('.slider-homepage').slick({
    dots: true,
    arrows: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
    nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
    appendDots: '#container-dots-homepage',
    appendArrows: '#container-arrows-homepage'
  });
  (0, _jquery2.default)('.slider-product').each(function (index, element) {
    var tagArrowLeft = (0, _jquery2.default)(element).data('tag-arrow-left');
    var tagArrowRight = (0, _jquery2.default)(element).data('tag-arrow-right');
    (0, _jquery2.default)(element).on('init', function (event, slick, direction) {
      (0, _jquery2.default)('.slick-slide a', (0, _jquery2.default)(element)).each(function (index2, element2) {
        var id = (0, _jquery2.default)(element2).data('id');
        (0, _jquery2.default)(element2).attr('id', id);
      });
      checkSliderNote((0, _jquery2.default)(element));
    });
    (0, _jquery2.default)(element).on('breakpoint', function (event, slick, breapoint) {
      checkSliderNote((0, _jquery2.default)(element));
    });
    (0, _jquery2.default)(element).slick({
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 2.5,
      slidesToScroll: 2,
      infinite: false,
      prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
      nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
      appendArrows: (0, _jquery2.default)('.container-arrows-products', (0, _jquery2.default)(element).closest('.row')),
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }]
    });
    checkSliderNote((0, _jquery2.default)(element));
  });
  function checkSliderNote($element) {
    var $row = (0, _jquery2.default)($element).closest('.row');
    if ((0, _jquery2.default)('.container-arrows-products', $row).text().trim() == '') (0, _jquery2.default)('.slider-note', $row).hide();else (0, _jquery2.default)('.slider-note', $row).show();
  }
});